// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

// import CustomInputTextExample from "./example/CustomInputExample";
import { QuestionnaireRenderComponents } from "components/ui/Questionnaire/QuestionnaireTypes";

/**
 * Put your custom input controllers here. It has to be a react
 * component accepting props of the type QuestionnaireInputProps.
 * See the example below and the implementation code of the example.
 */

export const QuestionnaireComponentOverrides: QuestionnaireRenderComponents = {
  // text: CustomInputTextExample,
};
